// ConnectedAccountsSection.tsx — Settings → Connected Accounts.
//
// ═══ DELIBERATELY DECORATIVE — no control here performs a link. ═══
// Signing in with Google or Apple exists on the sign-in page (1.25.00), but
// linking a provider to an EXISTING account from Settings does not: there is
// nothing real for a Connect button to do, so every provider row renders its
// button DISABLED with a "Coming soon" chip rather than pretending a flow exists.
// When linking lands, wire the buttons and drop the chips. The provider list is
// shared with the Account Settings dashboard (connectedProviders.ts).
import styled from 'styled-components';
import { Panel, Button } from '@/ui';
import { CONNECTED_PROVIDERS } from './connectedProviders';

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Card = styled(Panel)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CardTitle = styled.h3`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const RowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const RowLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;

const RowHint = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
  max-width: 44ch;
`;

const RowEnd = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SoonChip = styled.span`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: 500;
  color: ${({ theme }) => theme.color.textMuted};
`;

const Blurb = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function ConnectedAccountsSection() {
  return (
    <Stack>
      <Card>
        <CardTitle>Linked accounts</CardTitle>
        {CONNECTED_PROVIDERS.map((p) => (
          <Row key={p.id} data-testid={`provider-${p.id}`}>
            <RowText>
              <RowLabel>{p.label}</RowLabel>
              <RowHint>{p.hint}</RowHint>
            </RowText>
            <RowEnd>
              <SoonChip>Coming soon</SoonChip>
              <Button variant="secondary" disabled>
                Connect
              </Button>
            </RowEnd>
          </Row>
        ))}
        <Blurb>
          Account linking isn&apos;t available yet. Your TruXSocial account works on its own.
          Linking will only ever be an optional convenience, never a requirement.
        </Blurb>
      </Card>
    </Stack>
  );
}
